import { Injectable } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class StructureTagService {

  constructor() {}

    structureDisplayTag(value:any, meta:any) {
        const tagObj = {}
        for (const tag of meta.tagslist) {
            tagObj[tag.val]=tag.disp
        }
        for (const key in value) {
            const newarr=[]
            for (let tagkey of value[key]){
                newarr.push(tagObj[tagkey])
            }
            value[key]=newarr    
        }
    }

    structureTagPost(tagsData:any,) {
        let tags = {};
        if(tagsData){
            for (let tagkey in tagsData){
                tags[tagkey]=[]
                for(let tag in tagsData[tagkey]){
                    if(tagsData[tagkey][tag]){
                        tags[tagkey].push(tag)
                    }
                }
            }
            return tags;

        } else {
            return null;
        }
    }

    provideControlTags(tagMeta:any) {

        let tagobj = {}
        for(let tag in tagMeta.mapping){
            tagobj[tag]=[]
        }
        tagMeta.tagslist.forEach((tag:any)=>{
            tagobj[tag.parent].push(tag)
        })
        return this.createTagControl(tagobj)
    }

    tagarrtoObj(tagData:any) {
        let tags={}
        for(const tagkey in tagData){
            tags[tagkey]={}
            for (const tag of tagData[tagkey]){
                tags[tagkey][tag]=true;
            }
        }
        return tags;
    }

    createTagControl(tsdstr:any){
        const tags = new FormGroup({})
        function getTags(tag:string){
            return tags.get(tag) as UntypedFormGroup
        }

        for (const key in tsdstr) {
            tags.addControl(key, new FormGroup({}))
            const taggroup = getTags(key)
            for (const tag of tsdstr[key]){
                taggroup.addControl(tag.val,new FormControl(false))
            }
        }
        return tags;
    }

    tagarrObj(val:any){
        let obj = {}
        for(const tag of val){
            obj[tag.val]=tag
        }
        return obj
    }

    createsetsforalert(tagvalue:any,mapppingtag:any){
        let set = new Set();
        for (const taggrp in tagvalue){
            for(const tag in tagvalue[taggrp]){ 
                if(tagvalue[taggrp][tag]){{
                    set.add(mapppingtag[tag])
                }}
            }
        }
        return set;
    }
}